import { useEffect, useState } from 'react';
import { auth } from '@/lib/firebase';

/** True if the signed-in user carries the `admin` custom claim. */
export function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let active = true;
    auth.currentUser
      ?.getIdTokenResult()
      .then((result) => {
        if (active) setIsAdmin(!!result.claims.admin);
      })
      .catch(() => {
        if (active) setIsAdmin(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return isAdmin;
}
